/**
 * @generated SignedSource<<e371f514da5bf1a46fffc8e1876d69d3>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type useContentViewsDetailsPanelContentViewsQuery_contentAnalyticsViewers_ContentAnalyticsViewers =
  {
    __typename?: "ContentAnalyticsViewers";
    count: number;
  };
export type useContentViewsDetailsPanelContentViewsQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    permissionType: SitePermissionType | null;
  };
export type useContentViewsDetailsPanelContentViewsQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  confluence: useContentViewsDetailsPanelContentViewsQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type useContentViewsDetailsPanelContentViewsQuery_Query = {
  __typename?: "Query";
  contentAnalyticsViewers?: useContentViewsDetailsPanelContentViewsQuery_contentAnalyticsViewers_ContentAnalyticsViewers | null;
  user: useContentViewsDetailsPanelContentViewsQuery_user_AtlassianUser | null;
};
export type useContentViewsDetailsPanelContentViewsQueryVariables = Exact<{
  contentId: Scalars["ID"]["input"];
  isDraft: Scalars["Boolean"]["input"];
}>;
export type useContentViewsDetailsPanelContentViewsQuery =
  useContentViewsDetailsPanelContentViewsQuery_Query;
